import React, { useState, useEffect } from 'react';
import OutputType from './ComponentsTpes/OutputType';

const EntryRelay = ({ selectedType, fieldsData, componentSourceOptions, selectedPorts, setSelectedPorts,
    savedData, setSavedData
}) => {
    const selectOptions = (key, value) => {
        setSavedData(prevData => {
            return {
                ...prevData,
                Entry_relay: {
                    ...prevData.Entry_relay,
                    [key]: value
                }
            }
        })
    }
    return <OutputType
        selectedPorts={selectedPorts}
        setSelectedPorts={setSelectedPorts}
        source={componentSourceOptions.outputsData}
        selectOptions={selectOptions}
        component_source={savedData.Entry_relay.component_source.value}
        condition={savedData.Entry_relay.condition}
        output={savedData.Entry_relay.output}
        // selectedType={savedData.Entry_relay.selectedType}
        name={savedData.Entry_relay.name}
        relay_mode={savedData.Entry_relay.relay_mode}
        impulse_time={savedData.Entry_relay.impulse_time}
        entry_exit_open_durations={savedData.Entry_relay.entry_exit_open_durations}
        sensorAutolock={savedData.Entry_relay.sensorAutolock}
        fieldsData={fieldsData}
    />
}

export default EntryRelay;